var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"el",staticClass:"frc-captcha",class:_vm.classes,attrs:{"data-sitekey":_vm.sitekey}})}
var staticRenderFns = []

export { render, staticRenderFns }